import React from 'react';
import InventoryPanel from '../components/inventory/InventoryPanel';

// BAR-124: /inventory route — the regulatory inventory (read-only slice).
// Data comes from inventory_service; see backend/inventory_service/README.md.
export default function InventoryRoute() {
  return (
    <div className="h-full overflow-y-auto bg-bg">
      <InventoryPanel />
    </div>
  );
}
